export const CHART_COLORS = [
  '#FF4016',
  '#00B191',
  '#2370FF',
  '#FCAF00',
  '#CC0909',
  '#EA346F',
  '#C10152',
  '#691EFF',
  '#29D058',
  '#59a4a6',
  '#009EE3',
  '#3DD3DD',
];

export const getComparatorUniqueSeries = (data: Record<string, number | string>[]) => {
  const series: string[] = [];

  data.forEach((entry) => {
    Object.keys(entry).forEach((key) => {
      if (key !== 'hour' && !series.includes(key)) {
        series.push(key);
      }
    });
  });

  return series;
};
